import React from 'react';
import CollapsedFlightDetailItem from './CollapsedFlightDetailItem';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAircraftFromList,
  clearSelectedFlight
} from '../../redux/reducers/aircraftReducer/thunk';
import { getSelectedFlightAircraftId } from '../../redux/selectors/flyingPage';
import ExpandedFlightDetailItem from './ExpandedFlightDetail/ExpandedFlightDetailItem';

interface FlightDetailItemContainerProps {
  aircraftId: string;
}

export const FlightDetailItemContainer: React.FC<FlightDetailItemContainerProps> = ({
  aircraftId
}) => {
  const dispatch = useDispatch();
  const selectedAircraftId = useSelector(getSelectedFlightAircraftId);

  const onClickHandler = () => {
    if (selectedAircraftId === aircraftId) {
      dispatch(clearSelectedFlight());
    } else {
      dispatch(selectAircraftFromList(aircraftId));
    }
  };

  return (
    <div onClick={onClickHandler}>
      {selectedAircraftId === aircraftId ? (
        <ExpandedFlightDetailItem aircraftId={aircraftId} />
      ) : (
        <CollapsedFlightDetailItem aircraftId={aircraftId} />
      )}
    </div>
  );
};
